import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'components';
import { BasketPageBarContent } from 'services/content';
import { useFeatureFlagCheck } from 'hooks';
import { infoCircleTeal } from 'assets';
import styles from './styles.module.css';

const BasketPageBar = ({ price, callBack, isPharmacyCollection, disabled, isManual = false }) => {
  const isCost = price !== '0.00';
  const [isFeatureEnabled] = useFeatureFlagCheck();

  return (
    <div className={styles.basketPageBar}>
      <div className="coop-l-container">
        <div className={styles.basketPageBarInner}>
          <div
            className={`${styles.basketPageBarCopy} ${
              isCost ? styles.basketPageBarCopyCost : styles.basketPageBarCopyFree
            }`}>
            {isCost && !isPharmacyCollection ? (
              <Message
                type="basket-bar"
                icon={!isManual && infoCircleTeal}
                price={price}
                header={isManual ? BasketPageBarContent.headerManualText : BasketPageBarContent.headerText}
                text={
                  isManual
                    ? BasketPageBarContent.subHeaderManualText
                    : BasketPageBarContent.subHeaderText
                }
              />
            ) : null}
          </div>
          <button
            id="order-medication-button"
            onClick={() => callBack()}
            className={`coop-btn coop-btn--primary ${styles.button}`}
            type="button"
            disabled={disabled}>
            <div>
              <div>{BasketPageBarContent.buttonText}</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

BasketPageBar.propTypes = {
  price: PropTypes.string.isRequired,
  callBack: PropTypes.func.isRequired,
};

export default BasketPageBar;
